import { useRouter } from 'next/router';

/** Check if the actual route is a checkout route */
const isCheckoutRoute = (pathname: string) => pathname.includes('/(fr/)?kasse');

export const useIsCheckoutRoute = () => {
  const { pathname } = useRouter();
  return isCheckoutRoute(pathname);
};
